import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/app/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _wrapNativeSuper from "/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { compactToU8a, u8aConcatStrict, u8aToHex } from '@polkadot/util';
import { compareArray } from "../utils/compareArray.js";
/**
 * @name AbstractArray
 * @description
 * This manages codec arrays. It is an extension to Array, providing
 * specific encoding/decoding on top of the base type.
 * @noInheritDoc
 */

export var AbstractArray = /*#__PURE__*/function (_Array) {
  _inherits(AbstractArray, _Array);

  var _super = _createSuper(AbstractArray);

  function AbstractArray(registry, length) {
    var _this;

    _classCallCheck(this, AbstractArray);

    _this = _super.call(this, length);
    _this.registry = registry;
    return _this;
  }
  /**
   * @description The length of the value when encoded as a Uint8Array
   */


  _createClass(AbstractArray, [{
    key: "encodedLength",
    get: function get() {
      // We need to loop through all entries since they may have a variable length themselves,
      // e.g. when a Vec or Compact is contained withing, it has a variable length based on data
      var total = compactToU8a(this.length).length;

      for (var i = 0; i < this.length; i++) {
        total += this[i].encodedLength;
      }

      return total;
    }
    /**
     * @description returns a hash of the contents
     */

  }, {
    key: "hash",
    get: function get() {
      return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return this.length === 0;
    }
    /**
     * @description The length of the value
     */

  }, {
    key: "length",
    get: function get() {
      // only included here since we ignore inherited docs
      return _get(_getPrototypeOf(AbstractArray.prototype), "length", this);
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */

  }, {
    key: "eq",
    value: function eq(other) {
      return compareArray(this, other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */

  }, {
    key: "inspect",
    value: function inspect() {
      return {
        inner: this.inspectInner(),
        outer: [compactToU8a(this.length)]
      };
    }
  }, {
    key: "inspectInner",
    value: function inspectInner() {
      var inner = new Array(this.length);

      for (var i = 0; i < this.length; i++) {
        inner[i] = this[i].inspect();
      }

      return inner;
    }
    /**
     * @description Converts the Object to an standard JavaScript Array
     */

  }, {
    key: "toArray",
    value: function toArray() {
      return Array.from(this);
    }
    /**
     * @description Returns a hex string representation of the value
     */

  }, {
    key: "toHex",
    value: function toHex() {
      return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman(isExtended) {
      var result = new Array(this.length);

      for (var i = 0; i < this.length; i++) {
        result[i] = this[i].toHuman(isExtended);
      }

      return result;
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var result = new Array(this.length);

      for (var i = 0; i < this.length; i++) {
        result[i] = this[i].toJSON();
      }

      return result;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

    /**
     * @description Returns the string representation of the value
     */

  }, {
    key: "toString",
    value: function toString() {
      var result = new Array(this.length);

      for (var i = 0; i < this.length; i++) {
        result[i] = this[i].toString();
      }

      return "[".concat(result.join(', '), "]");
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      var encoded = this.toU8aInner();
      return isBare ? u8aConcatStrict(encoded) : u8aConcatStrict([compactToU8a(this.length)].concat(_toConsumableArray(encoded)));
    }
  }, {
    key: "toU8aInner",
    value: function toU8aInner(isBare) {
      var encoded = new Array(this.length);

      for (var i = 0; i < this.length; i++) {
        encoded[i] = this[i].toU8a(isBare);
      }

      return encoded;
    } // Below are methods that we override. When we do a `new Vec(...).map()`,
    // we want it to return an Array. We only override the methods that return a
    // new instance.

    /**
     * @description Concatenates two arrays
     */

  }, {
    key: "concat",
    value: function concat(other) {
      return this.toArray().concat(other instanceof AbstractArray ? other.toArray() : other);
    }
    /**
     * @description Filters the array with the callback
     */

  }, {
    key: "filter",
    value: function filter(callbackfn, thisArg) {
      return this.toArray().filter(callbackfn, thisArg);
    }
    /**
     * @description Maps the array with the callback
     */

  }, {
    key: "map",
    value: function map(callbackfn, thisArg) {
      return this.toArray().map(callbackfn, thisArg);
    }
    /**
     * @description Checks if the array includes a specific value
     */

  }, {
    key: "includes",
    value: function includes(check) {
      return this.some(function (value) {
        return value.eq(check);
      });
    }
    /**
     * @description Returns a slice of an array
     */

  }, {
    key: "slice",
    value: function slice(start, end) {
      return this.toArray().slice(start, end);
    }
  }]);

  return AbstractArray;
}( /*#__PURE__*/_wrapNativeSuper(Array));